import cn from 'classnames';
import get from 'lodash/get';
import Link from 'next/link';
import { useState, useEffect } from 'react';

import { productsQuantities } from '../../store/cart';
import OrderLimitationsStore from '../../store/orderLimitations';
import { offerLink, getProductOrderLimit, productsLimitReached } from '../../utils/products';
import ButtonCart from '../RoundButton/ButtonCart';

import offerStyles from './OfferTile.module.scss';
import styles from './ProductListItem.module.scss';

const DISABLED_OFFER_WARNING = 'Το συγκεκριμένο προϊόν δεν είναι πλέον διαθέσιμο';

export default function OfferTile({ offer, isHomeOffer, disabled = false }) {
  const priceString = `€ ${(offer.price / 100).toFixed(2)} `;
  const [displayInfoWindow, setDisplayInfoWindow] = useState(false);
  const [productLimit, setProductLimit] = useState({});
  const [productQuantity, setProductQuantity] = useState('');

  function offerUOM(_offer) {
    if (_offer.products.length !== 0 || _offer.groups.length !== 0) {
      return 'το σετ';
    }
    return 'το τεμάχιο';
  }

  function productsLimitReachedWrapper(limit) {
    const quantity = productsQuantities.getValue();
    productsLimitReached(offer, quantity[offer._id], setDisplayInfoWindow, limit);
  }

  useEffect(() => {
    const productsQuantities$ = productsQuantities.subscribe(productQuantities => {
      const _productQuantity = productQuantities[offer._id];
      setProductQuantity(_productQuantity);
    });
    const orderLimitations$ = OrderLimitationsStore.subscribe(orderLimitations => {
      const limit = getProductOrderLimit(orderLimitations, offer);
      setProductLimit(limit);
    });
    return () => {
      orderLimitations$.unsubscribe();
      productsQuantities$.unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (!productLimit) return;
    productsLimitReachedWrapper(productLimit);
  }, [productQuantity, productLimit]);

  const imgSrc = get(offer, 'image.webSmallThumb', '');
  const searchResultsImage = offer.image.baseUrl + offer.image.primary;

  return (
    <div
      className={cn(styles.productItem, {
        [offerStyles.offerProductItem]: isHomeOffer,
        [styles.disabledProduct]: disabled,
      })}
      title={disabled ? DISABLED_OFFER_WARNING : undefined}
    >
      <Link href={offerLink(offer)}>
        <a className={styles.productLink}>
          <div className={styles.layoutSmall}>
            <header className={styles.header}>
              <div className={styles.badgeOffer}>{offer.webSticker}</div>
              <img
                loading="lazy"
                src={imgSrc || searchResultsImage}
                width="200"
                height="200"
                className={styles.productImage}
                alt={offer.name}
              />
              {displayInfoWindow && (
                <div className={styles.infoWindow}>
                  <p>Έχεις φτάσει την μέγιστη ποσότητα προϊόντος</p>
                </div>
              )}
            </header>
            <main className={styles.main}>
              <p className={styles.title}>{offer.name}</p>
              <p className={styles.titleDesc} title={offer.description}>
                {offer.description}
              </p>
              <p className={styles.description}>
                {priceString}
                {offerUOM(offer)}
              </p>
            </main>
          </div>
        </a>
      </Link>
      <div className={cn(styles.btnContainer, offerStyles.btnContainer)}>
        <div className={styles.priceFooter}>
          <div className={styles.finalPriceContainer}>
            <p className={styles.finalPrice}>{priceString}</p>
          </div>
        </div>
        <ButtonCart
          product={offer}
          productLimit={productLimit}
          quantity={productQuantity}
          isEditable
          removed={disabled}
        />
      </div>
    </div>
  );
}
